import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import SelectIcon from "../Icons/SelectIcon";

import styles from "./button-group.module.scss";

function ButtonGroup(props) {
  const {current, buttons, renderButton, vendorStyle, onChange} = props;
  return (
    <div className={styles.root}>
      {buttons.map((item) => {
        const selected = current === item.value;
        return (
          <button
            key={item.value}
            disabled={item.disabled}
            onClick={() => onChange(item.value)}
            className={classNames(styles.button, {
              [styles.buttonActive]: selected,
              [styles[`vendor-${vendorStyle}`]]: vendorStyle
            })}
          >
            {selected && (
              <span className={styles.check}>
                <SelectIcon fill="#fff"/>
              </span>
            )}
            {renderButton(item)}
          </button>
        );
      })}
    </div>
  );
}

ButtonGroup.propTypes = {
  current: PropTypes.string,
  buttons: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string
    })
  ),
  renderButton: PropTypes.func,
  onChange: PropTypes.func,
  vendorStyle: PropTypes.string
};

export default ButtonGroup;
